export default __webpack_public_path__ + "static/CenturyGothic-Italic-01a49284e867c37d708102d8135b1cc4.ttf";